import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CartItemComponentOptions, PromotionLocation } from "@spartacus/cart/base/root";
import { VendorOrderEntryGroup } from '../../uig-cart.models';

@Component({
    selector: 'app-uig-grouped-cart-item-list',
    templateUrl: './uig-grouped-cart-item-list.component.html',
    styleUrls: ['./uig-grouped-cart-item-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigGroupedCartItemListComponent {

  @Input() readonly: boolean = false;
  @Input() hasHeader: boolean = true;
  @Input() savedCarts?: boolean;
  @Input() options: CartItemComponentOptions = {
    isSaveForLater: false,
    optionalBtn: null,
  };

  @Input() cartId: string;
  @Input('items') items;

  @Input() promotionLocation: PromotionLocation = PromotionLocation.ActiveCart;

  @Input('cartIsLoading') cartIsLoading;

  @Input() vendorEntryGroups: VendorOrderEntryGroup[];


  
}
